
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const WohnungsvermietungPage = () => {
  useEffect(() => {
    document.title = 'Wohnungsvermietung - Jo Allround Service';
    
    // Schema.org JSON-LD für Wohnungsvermietung
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Wohnungsvermietung - Jo Allround Service",
      "description": "Wohnungsvermietung von Jo Allround Service - Folgt in Kürze. Kontaktieren Sie uns für weitere Informationen.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://jo-allround.de'}/wohnungsvermietung`,
      "mainEntity": {
        "@type": "RealEstateAgent",
        "name": "Jo Allround Service",
        "description": "Wohnungsvermietung - Folgt in Kürze",
        "telephone": "03943 / 62 66 73",
        "email": "J-Born@T-Online.de",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Rheinsberg",
          "@addressRegion": "Brandenburg",
          "addressCountry": "DE"
        }
      }
    });
    
    // Entferne vorhandenes Schema falls vorhanden
    const existingSchema = document.querySelector('script[type="application/ld+json"][data-page="wohnungsvermietung"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    schemaScript.setAttribute('data-page', 'wohnungsvermietung');
    document.head.appendChild(schemaScript);
    
    return () => {
      const script = document.querySelector('script[type="application/ld+json"][data-page="wohnungsvermietung"]');
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        <div className="min-h-[calc(100vh-160px)] flex items-center justify-center px-4 py-16">
          <div className="text-center max-w-4xl mx-auto">
            {/* Wohnungsbild */}
            <div className="mb-12 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/2444a727b098ad6afd451d338e3cc621.jpg"
                alt="Moderne Wohnung"
                className="w-full h-[400px] object-cover object-top"
              />
            </div>

            {/* Coming Soon Text */}
            <div className="mb-12">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                Folgt in Kürze
              </h1>
              <p className="text-xl md:text-2xl text-gray-600">
                Wohnungsvermietung
              </p>
            </div>

            {/* Kontaktinformationen */}
            <div className="bg-gray-50 p-8 rounded-xl mb-8">
              <p className="text-lg text-gray-700 mb-6">
                Für Anfragen zur Wohnungsvermietung kontaktieren Sie uns gerne:
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a 
                  href="tel:03943626673" 
                  className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-6 h-6 flex items-center justify-center mr-2">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  03943 / 62 66 73
                </a>
                <a 
                  href="mailto:J-Born@T-Online.de" 
                  className="inline-flex items-center bg-gray-800 text-white px-6 py-3 rounded-lg hover:bg-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-6 h-6 flex items-center justify-center mr-2">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  E-Mail senden
                </a>
              </div>
            </div>

            {/* Zurück Button */}
            <div className="mt-12">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center mr-2">
                  <i className="ri-arrow-left-line text-lg"></i>
                </div>
                Zurück zur Startseite
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default WohnungsvermietungPage;
